import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import AppShell from "./components/AppShell";
import UpgradeModal from "./components/UpgradeModal";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ContactsList from "./pages/ContactsList";
import ContactDetail from "./pages/ContactDetail";
import ScanCard from "./pages/ScanCard";
import FollowUps from "./pages/FollowUps";
import Templates from "./pages/Templates";
import Campaigns from "./pages/Campaigns";
import Profile from "./pages/Profile";
import MyCard from "./pages/MyCard";
import PublicCard from "./pages/PublicCard";
import AuthCallback from "./pages/AuthCallback";
import Events from "./pages/Events";
import Pricing from "./pages/Pricing";
import PaySuccess from "./pages/PaySuccess";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import BookCall from "./pages/BookCall";
import Setup from "./pages/Setup";
import AdminUsers from "./pages/AdminUsers";
import AdminLeads from "./pages/AdminLeads";
import EmailSetup from "./pages/EmailSetup";
import EmailAutomation from "./pages/EmailAutomation";
import Settings from "./pages/Settings";
import Tasks from "./pages/Tasks";
import CampaignBuilder from "./pages/CampaignBuilder";
import Organizations from "./pages/Organizations";
import AdminHealth from "./pages/AdminHealth";
import AccountData from "./pages/AccountData";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#A3A3A3]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UpgradeModal />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/c/:slug" element={<PublicCard />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/book-a-call" element={<BookCall />} />
          <Route path="/setup" element={<Protected><Setup /></Protected>} />
          <Route path="/pay/success" element={<Protected><PaySuccess /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/contacts" element={<Protected><ContactsList /></Protected>} />
          <Route path="/contacts/:id" element={<Protected><ContactDetail /></Protected>} />
          <Route path="/scan" element={<Protected><ScanCard /></Protected>} />
          <Route path="/follow-ups" element={<Protected><FollowUps /></Protected>} />
          <Route path="/templates" element={<Protected><Templates /></Protected>} />
          <Route path="/campaigns" element={<Protected><Campaigns /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/my-card" element={<Protected><MyCard /></Protected>} />
          <Route path="/events" element={<Protected><Events /></Protected>} />
          <Route path="/admin/users" element={<Protected><AdminUsers /></Protected>} />
          <Route path="/admin/leads" element={<Protected><AdminLeads /></Protected>} />
          <Route path="/dashboard/email-setup" element={<Protected><EmailSetup /></Protected>} />
          <Route path="/dashboard/email-automation" element={<Protected><EmailAutomation /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/tasks" element={<Protected><Tasks /></Protected>} />
          <Route path="/campaigns/:id" element={<Protected><CampaignBuilder /></Protected>} />
          <Route path="/organizations" element={<Protected><Organizations /></Protected>} />
          <Route path="/account/data" element={<Protected><AccountData /></Protected>} />
          <Route path="/admin/health" element={<Protected><AdminHealth /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
